import { isSelectedCalendar } from '../selectors/isSelectedCalendar';
import { getStore } from '../store/store';
import { insertCalendar } from '../utils/insertCalendar';
import { sortByGroups } from '../utils/sortByGroups';
import type { Calendar } from 'owa-calendar-cache';
import { mutatorAction } from 'satcheljs';

// VSO 54879 Improve resiliency of de-duping selected calendars in read+write scenarios
// Long-term, this should be deprecated in favor of relying on Sets and Satchel v3 architecture
export const selectCalendar = mutatorAction('SELECT_CALENDAR', (calendar: Calendar) => {
    if (!isSelectedCalendar(calendar)) {
        const sortedCalendars = sortByGroups(getStore().calendars, getStore().calendarGroups);
        insertCalendar(calendar, getStore().selectedCalendars, sortedCalendars);
    }
});
